import PatientServiceItem from './_PatientServiceItem';

export default PatientServiceItem;
